import React, { useState } from 'react';
import {
    Box, Typography, Paper, Button, Stack,
    Divider, Tooltip, CircularProgress
} from '@mui/material';
import { ShieldCheck, FileCheck, Download, Copy, Check } from 'lucide-react';
import { validarUserByCpfApi } from '../../Api';

export default function CardValidacaoDigitalUEN({ walletStatus, cpf, nome }) {
    const codPem = `-----BEGIN CERTIFICATE-----
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
-----END CERTIFICATE-----`;

    const [copied, setCopied] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    const handleCopyPem = () => {
        navigator.clipboard.writeText(codPem);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const handleDownload = async () => {
        if (isDownloading) return;
        setIsDownloading(true);
        try {
            const response = await validarUserByCpfApi({ cpf });
            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = isMobile ? `${nome}validadorDigitalUEN.pdf` : `${nome}validadorDigitalUEN.pdf`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error("Erro ao baixar PDF UEN:", err);
        } finally {
            setIsDownloading(false);
        }
    };

    return (
        // O Box abaixo cria a margem lateral (mx: 2 dá um espaçamento de 16px de cada lado)
        <Box sx={{ mx: { xs: 2, sm: 3, md: 0 }, my: 2 }}>
            <Paper
                elevation={0}
                sx={{
                    p: { xs: 3, md: 4 },
                    borderRadius: '28px',
                    background: 'linear-gradient(135deg, rgba(255,255,255,0.98) 0%, rgba(240,247,255,0.95) 100%)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(22, 111, 122, 0.2)', // Borda leve na cor tema
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 3,
                    position: 'relative',
                    overflow: 'hidden'
                }}
            >
                <Box sx={{ position: 'absolute', top: 6, right: 6, color: 'rgba(22, 111, 122, 0.05)' }}>
                    <ShieldCheck size={140} />
                </Box>

                <Stack direction="row" spacing={2} alignItems="center">
                    <Box sx={{ p: 1.5, bgcolor: 'rgba(22, 111, 122, 0.1)', color: '#166f7a', borderRadius: '14px' }}>
                        <FileCheck size={28} />
                    </Box>
                    <Box>
                        <Typography variant="h6" fontWeight="900" color="#1a1a1a" sx={{ fontSize: '1.1rem' }}>
                            Autenticidade UEN
                        </Typography>
                        <Typography variant="caption" color="text.secondary" fontWeight="600">
                            Chave Pública ICP-Brasil
                        </Typography>
                    </Box>
                </Stack>

                <Divider sx={{ opacity: 0.1 }} />

                <Box>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2, lineHeight: 1.6, fontWeight: 500 }}>
                        Certificado PEM oficial para validação da identidade estudantil UEN em sistemas externos.
                    </Typography>

                    <Tooltip title={copied ? "Copiado!" : "Clique para copiar o PEM"}>
                        <Box
                            onClick={handleCopyPem}
                            sx={{
                                bgcolor: '#ffffff',
                                p: 2,
                                borderRadius: '16px',
                                border: '1.5px solid rgba(22, 111, 122, 0.15)',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease-in-out',
                                '&:hover': { borderColor: '#166f7a' }
                            }}
                        >
                            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1.5 }}>
                                <Typography variant="caption" sx={{ fontWeight: 800, color: '#166f7a', letterSpacing: 0.5 }}>
                                    PEM UEN-DIGITAL
                                </Typography>
                                <Stack direction="row" spacing={1} alignItems="center">
                                    {copied ? <Check size={16} color="#166f7a" /> : <Copy size={16} color="#166f7a" />}
                                </Stack>
                            </Stack>

                            <Box sx={{
                                maxHeight: '120px',
                                overflowY: 'auto',
                                '&::-webkit-scrollbar': { width: '4px' },
                                '&::-webkit-scrollbar-thumb': { bgcolor: 'rgba(22, 111, 122, 0.2)', borderRadius: '10px' }
                            }}>
                                <Typography sx={{ fontFamily: 'monospace', fontSize: '0.65rem', color: '#444', wordBreak: 'break-all' }}>
                                    {codPem}
                                </Typography>
                            </Box>
                        </Box>
                    </Tooltip>
                </Box>

                <Button
                    variant="contained"
                    fullWidth
                    disabled={walletStatus === 'expired' || isDownloading}
                    onClick={handleDownload}
                    startIcon={isDownloading ? <CircularProgress size={20} color="inherit" /> : <Download size={20} />}
                    sx={{
                        py: 2,
                        borderRadius: '14px',
                        bgcolor: '#166f7a', // Aplicando sua cor exata
                        fontWeight: '800',
                        textTransform: 'none',
                        '&:hover': { bgcolor: '#125a63' } // Tom mais escuro para o hover
                    }}
                >
                    {walletStatus === 'expired' ? 'Documento Expirado' : isDownloading ? 'Gerando PDF...' : 'Baixar Comprovante UEN'}
                </Button>
            </Paper>
        </Box>
    );
}